import http from 'hub-http/clients/apiClient';
import { QUICK_FETCH_WORDPRESS_STATUS_KEY } from '../constants/taskConstants';
import { getEarlyRequestByKey } from '../utils/earlyRequestUtils';
function fetchIsWordpress() {
  return http.get('plugins/v1/discovery');
}
export function getIsWordpress() {
  return getEarlyRequestByKey(QUICK_FETCH_WORDPRESS_STATUS_KEY, () => fetchIsWordpress());
}